import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    boxShadow: 'none',
  },
  flexGrow: {
    flexGrow: 1,
  },
  search: {
    backgroundColor: theme.palette.type === 'dark' 
      ? 'rgba(10, 37, 64, 0.12)' 
      : 'rgba(255, 255, 255, 0.15)', 
    borderRadius: 6,
    flexBasis: 400,
    height: 36,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center',
    border: theme.palette.type === 'dark'
      ? '1px solid rgba(10, 37, 64, 0.15)' 
      : '1px solid rgba(255, 255, 255, 0.1)', 
    transition: theme.transitions.create(['background-color', 'box-shadow']),
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark'
        ? 'rgba(10, 37, 64, 0.2)' 
        : 'rgba(255, 255, 255, 0.22)',
    },
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.type === 'dark' 
      ? 'rgba(10, 37, 64, 0.8)' 
      : 'rgba(255, 255, 255, 0.9)', 
  },
  searchInput: {
    flexGrow: 1,
    color: theme.palette.topbarContrastText, 
    fontSize: '0.875rem',
    '& input::placeholder': {
      opacity: 1,
      color: theme.palette.type === 'dark' 
        ? 'rgba(10, 37, 64, 0.7)' 
        : 'rgba(255, 255, 255, 0.7)', 
    },
  },
  searchPopper: {
    zIndex: theme.zIndex.appBar + 100,
    width: 380, 
    maxWidth: '100%',
  },
  searchPopperContent: {
    marginTop: theme.spacing(1.5),
    overflow: 'auto',
    maxHeight: '70vh', 
    borderRadius: '14px',
    boxShadow: theme.palette.type === 'dark' 
      ? '0 20px 25px -5px rgba(0, 0, 0, 0.5), 0 10px 10px -5px rgba(0, 0, 0, 0.4)'
      : '0 20px 25px -5px rgba(0, 0, 0, 0.08), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    border: `1px solid ${theme.palette.divider}`,
    background: theme.palette.background.paper,
  },
  popperHeader: {
    padding: theme.spacing(2, 2, 1, 2),
  },
  popperTitle: {
    fontWeight: 700,
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '1.2px',
    color: theme.palette.text.disabled,
  },
  searchList: {
    width: '100%',
    padding: theme.spacing(0, 0, 1, 0),
  },
  searchListItem: {
    padding: theme.spacing(1.5, 2),
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: theme.palette.type === 'dark' 
        ? 'rgba(255, 255, 255, 0.03)' 
        : 'rgba(10, 37, 64, 0.03)',
    },
  },
  // O "Fundo Redondo" Oficial e Unificado Replicando 100% a classe caseAvatar do Caso.styles.js
  itemIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    borderRadius: '50%', // Absolutamente redondo conforme Caso.js!
    backgroundColor: theme.palette.type === 'dark' 
      ? 'rgba(59, 130, 246, 0.15)' // A mesma luz elétrica do Caso.js
      : 'rgba(10, 37, 64, 0.08)', // O mesmo Navy translúcido do Caso.js
    color: theme.palette.primary.main,
    marginRight: theme.spacing(2),
    flexShrink: 0,
  },
  itemIcon: {
    fontSize: '1.2rem', // Reduzido cirurgicamente para encaixar perfeitamente na bolha de 36px
    color: 'inherit',
  },
  imgLote: {
    width: 18,
    height: 18,
    filter: theme.palette.type === 'dark' 
      ? 'brightness(0) saturate(100%) invert(60%) sepia(66%) saturate(2931%) hue-rotate(202deg) brightness(101%) contrast(93%)' 
      : 'brightness(0) saturate(100%) invert(11%) sepia(21%) saturate(4496%) hue-rotate(188deg) brightness(93%) contrast(93%)', 
  },
  searchItemContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px',
    flexGrow: 1,
    minWidth: 0, // Defesa base para truncamento
  },
  searchItemTitle: {
    fontWeight: 600,
    fontSize: '0.85rem',
    color: theme.palette.text.primary,
    letterSpacing: '0.2px',
  },
  searchItemSub: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    minWidth: 0, // Obriga os filhos a obedecerem os limites de truncamento
  },
  searchItemDesc: {
    color: theme.palette.text.disabled,
    fontSize: '0.725rem',
    marginTop: theme.spacing(0.2),
    fontWeight: 400,
  },

  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
}))

export default useStyles
